import { SideMenuDrawerComponent as SideMenuDrawer } from "./sideMenuDrawer.component";

export default SideMenuDrawer;
